(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('EquipmentService', EquipmentService)
	EquipmentService.$inject = ['$http']
	function EquipmentService($http){
		var service = {
			getAllEquipmentByParent:getAllEquipmentByParent,
			getAllEquipmentByProperty:getAllEquipmentByProperty,
			getEquipmentByScope:getEquipmentByScope,
			getAllEquipment:getAllEquipment,
			getEquipment:getEquipment,
			addEquipment:addEquipment,
			attachEquipmentToParent:attachEquipmentToParent,
			detachEquipmentFromParent:detachEquipmentFromParent,
			updateEquipment:updateEquipment,
			deleteEquipment:deleteEquipment
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllEquipmentByParent(parentId,parentType){
			return $http.get('/api/equipment-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllEquipmentByProperty(propertyName,propertyValue){
			return $http.get('/api/equipment-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getEquipmentByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/equipment-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getEquipmentByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllEquipment(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-equipment';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getEquipment(equipmentId){
			return $http.get('/api/equipment/' + equipmentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function addEquipment(data){
			return $http.post('/api/equipment', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function updateEquipment(equipmentId, data){
			return $http.put('/api/equipment/' + equipmentId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};


		function attachEquipmentToParent(data){
			return $http.post('/api/attach-equipment-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachEquipmentFromParent(data){
			return $http.post('/api/detach-equipment-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteEquipment(equipmentId, data){
			return $http.delete('/api/equipment/' + equipmentId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('EventService', EventService)
	EventService.$inject = ['$http']
	function EventService($http){
		var service = {
			getAllEventsByParent:getAllEventsByParent,
			getAllEventsByProperty:getAllEventsByProperty,
			getEventsByScope:getEventsByScope,
			getAllEvents:getAllEvents,
			getEvent:getEvent,
			addEvent:addEvent,
			attachEventToParent:attachEventToParent,
			detachEventFromParent:detachEventFromParent,
			updateEvent:updateEvent,
			updateEventAdmin:updateEventAdmin,
			deleteEvent:deleteEvent
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllEventsByParent(parentId,parentType){
			return $http.get('/api/events-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllEventsByProperty(propertyName,propertyValue){
			return $http.get('/api/events-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getEventsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/events-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getEventsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllEvents(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-events';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getEvent(eventId){
			return $http.get('/api/event/' + eventId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function addEvent(data){
			return $http.post('/api/event', data)
			.then(function(response){
				if(response.status == 200){
					var payload = response.data.payload;
					payload.redirect = response.data.redirect;
					return payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function updateEvent(eventId, data){
			return $http.put('/api/event/' + eventId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function updateEventAdmin(eventId, data){
			return $http.put('/api/event/' + eventId + '/admin', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function attachEventToParent(data){
			return $http.post('/api/attach-event-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachEventFromParent(data){
			return $http.post('/api/detach-event-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteEvent(eventId, data){
			return $http.delete('/api/event/' + eventId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.service('fileUpload', ['$http', function ($http) {
	this.uploadFileToUrl = function(file, uploadUrl, addons){
		console.log("ADDONS", addons);
		var fd = new FormData();
		fd.append('file', file);
		if(addons != undefined){
			fd.append('_token', addons._token);
			fd.append('parentType', addons.parentType);
			fd.append('parentId', addons.parentId);
			fd.append('description', addons.description);
			fd.append('category', addons.category);
		}
		return $http.post(uploadUrl, fd, {
			transformRequest: angular.identity,
			headers: {'Content-Type': undefined}
		});
	}
}]) 
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('NoteService', NoteService)
	NoteService.$inject = ['$http']
	function NoteService($http){
		var service = {
			getAllNotesByParent:getAllNotesByParent,
			getAllNotesByProperty:getAllNotesByProperty,
			getNotesByScope:getNotesByScope,
			getAllNotes:getAllNotes,
			getNote:getNote,
			addNote:addNote,
			attachNoteToParent:attachNoteToParent,
			detachNoteFromParent:detachNoteFromParent,
			updateNote:updateNote,
			deleteNote:deleteNote
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllNotesByParent(parentId,parentType){
			return $http.get('/api/notes-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllNotesByProperty(propertyName,propertyValue){
			return $http.get('/api/notes-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getNotesByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/notes-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getNotesByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllNotes(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-notes';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getNote(noteId){
			return $http.get('/api/note/' + noteId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function addNote(data){
			return $http.post('/api/note', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function updateNote(noteId, data){
			return $http.put('/api/note/' + noteId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};


		function attachNoteToParent(data){
			return $http.post('/api/attach-note-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachNoteFromParent(data){
			return $http.post('/api/detach-note-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteNote(noteId, data){
			return $http.delete('/api/note/' + noteId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('PreferenceService', PreferenceService)
	PreferenceService.$inject = ['$http']
	function PreferenceService($http){
		var service = {
			getAllPreferencesByParent:getAllPreferencesByParent,
			getAllPreferencesByProperty:getAllPreferencesByProperty,
			getPreferencesByScope:getPreferencesByScope,
			getAllPreferences:getAllPreferences,
			getPreference:getPreference,
			addPreference:addPreference,
			attachPreferenceToParent:attachPreferenceToParent,
			detachPreferenceFromParent:detachPreferenceFromParent,
			updatePreference:updatePreference,
			deletePreference:deletePreference
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllPreferencesByParent(parentId,parentType){
			return $http.get('/api/preferences-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllPreferencesByProperty(propertyName,propertyValue){
			return $http.get('/api/preferences-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getPreferencesByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/preferences-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getPreferencesByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllPreferences(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-preferences';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getPreference(preferenceId){
			return $http.get('/api/preference/' + preferenceId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function addPreference(data){
			return $http.post('/api/preference', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function updatePreference(preferenceId, data){
			return $http.put('/api/preference/' + preferenceId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};


		function attachPreferenceToParent(data){
			return $http.post('/api/attach-preference-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachPreferenceFromParent(data){
			return $http.post('/api/detach-preference-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deletePreference(preferenceId, data){
			return $http.delete('/api/preference/' + preferenceId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();

(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('UserService', UserService)
	UserService.$inject = ['$http']
	function UserService($http){
		return {
			getAllUsersByParent: getAllUsersByParent,
			getAllUsersByProperty: getAllUsersByProperty,
			getAllUsers: getAllUsers,
			getAllUserSimples: getAllUserSimples,
			getUsersLookup: getUsersLookup,
			getSearchUsers: getSearchUsers,
			getUser: getUser,
			addUser: addUser,
			reinviteUser: reinviteUser,
			updateUser: updateUser,
			updateUserRegister: updateUserRegister,
			updatePermissions: updatePermissions,
			attachRole: attachRole,
			detachRole: detachRole,
			attachUserToParent: attachUserToParent,
			detachUserFromParent: detachUserFromParent,
			deleteUser: deleteUser,
			getUnassociatedUsersByParent: getUnassociatedUsersByParent,
			getAllUsersByRole: getAllUsersByRole
		}
		function getAllUsersByParent(parentId,parentType){
			return $http.get('/api/users-by-parent/' + parentId + '/' + parentType)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsersByProperty(property1Name,property1Value){
			return $http.get('/api/all-users-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsers(){
			return $http.get('/api/all-users')
			.then(function(response){
				return {
					data: response.data.payload,
					count: response.data.count
				};
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUserSimples(){
			return $http.get('/api/all-user-simples')
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUsersLookup(){
			return $http.get('/api/users-lookup')
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getSearchUsers(){
			return $http.get('/api/search-users/' + parentId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUser(userId){
			return $http.get('/api/user/' + userId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function addUser(data){
			return $http.post('/api/user', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function reinviteUser(userId){
			return $http.post('/api/reinvite-user/' + userId)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateUser(userId, data){
			return $http.put('/api/user/' + userId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updateUserRegister(userId, data){
			return $http.put('/api/register/' + userId, data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function updatePermissions(data){
			return $http.post('/user-permission', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function attachRole(data){
			return $http.post('/api/user-attach-role', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function detachRole(data){
			return $http.post('/api/user-detach-role', data)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function attachUserToParent(data){
			return $http.post('/api/attach-user-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function detachUserFromParent(data){
			return $http.post('/api/detach-user-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function deleteUser(userId, data){
			return $http.delete('/api/user/' + userId)
			.then(function(response){

				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getUnassociatedUsersByParent(parentId,parentType){
			return $http.get('/api/unassociated-users-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});

		};

		function getAllUsersByRole(roleName){
            return $http.get('/api/all-users-by-role/' + roleName )
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();
(function(){
	'use strict';
	angular
	.module('myApp')
	.factory('VendorService', VendorService)
	VendorService.$inject = ['$http']
	function VendorService($http){
		var service = {
			getAllVendorsByParent:getAllVendorsByParent,
			getAllVendorsByProperty:getAllVendorsByProperty,
			getVendorsByScope:getVendorsByScope,
			getAllVendors:getAllVendors,
			getVendor:getVendor,
			addVendor:addVendor,
			attachVendorToParent:attachVendorToParent,
			detachVendorFromParent:detachVendorFromParent,
			updateVendor:updateVendor,
			deleteVendor:deleteVendor
		};
		return service;

		/*##############################################################################################
		methods
		##############################################################################################*/
		function getAllVendorsByParent(parentId,parentType){
			return $http.get('/api/vendors-by-parent/' + parentId + '/' + parentType)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllVendorsByProperty(propertyName,propertyValue){
			return $http.get('/api/vendors-by-property/' + propertyName + '/' + propertyValue)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getVendorsByScope(scopeName, count, queryParam, queryParam1) {
			var url = '/api/vendors-by-scope/' + scopeName;
			if ((count != undefined) && (count != '')) {
				url = url + '/' + count;
			}
			if ((queryParam != undefined) && (queryParam != '')) {
				url = url + '/' + queryParam;
			}
			if ((queryParam1 != undefined) && (queryParam1 != '')) {
				url = url + '/' + queryParam1;
			}
			return $http.get(url)
			.then(function (response) {
				if (response.status == 200) {
					return response.data.payload;
				} else {
					console.error("ERROR, Non-200 status received in getVendorsByScope: ", response);
				}
			})
			.catch(function (err) {
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getAllVendors(q,count){
			q = q || "";
			count = count || 1000;
			var url = '/api/all-vendors';
			if ((count != '')&&(q != '')) {
				url = url + '/' + q + '/' + count;
			}else if (q != '') {
				url = url + '/' + q;
			}
			return $http.get(url)
			.then(function(response){
				if(response.status == 200){
					return {
						data:response.data.payload,
						count:response.data.count
					};
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function getVendor(vendorId){
			return $http.get('/api/vendor/' + vendorId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function addVendor(data){
			return $http.post('/api/vendor', data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};

		function updateVendor(vendorId, data){
			return $http.put('/api/vendor/' + vendorId, data)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};


		function attachVendorToParent(data){
			return $http.post('/api/attach-vendor-to-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function detachVendorFromParent(data){
			return $http.post('/api/detach-vendor-from-parent', data)
			.then(function(response){
				return response.data.payload;
			})
			.catch(function(err){
				console.error("SERVICE ERROR(other): ", err);
				throw err;
			});
		};

		function deleteVendor(vendorId, data){
			return $http.delete('/api/vendor/' + vendorId)
			.then(function(response){
				if(response.status == 200){
					return response.data.payload;
				}else{
					console.error("ERROR, Non-200 status received: ", response);
				}
			})
			.catch(function(err){
				console.error("ERROR: ", err);
				throw err;
			});
		};
	}
})();

//# sourceMappingURL=services.js.map
